import { api } from "./api"

export const GET_ALL_AGENCIES = async () => {
    const {data} = await api.get(`/agencies/all`)
    return data;
}

export const DELETE_AGENCY = async (agencyId) => {
    const {data} = await api.delete(`/agencies/${agencyId}`)
    return data;
}

export const SAVE_AGENCY = async (params) => {
    const {data} = await api.post(`/agencies/save`, params)
    return data;
}
